export const youwellnow = {
	PAGE_THEME_ENABLED: false,
};
